import SimpleBar from 'simplebar'

export default {
  name: 'simplebar',

  componentDidMount () {
    /* eslint-disable-next-line */
    new SimpleBar(this.el)
  },
}
